// extracted by mini-css-extract-plugin
module.exports = {"root":"waitlist_root__mssLZ","infoContainer":"waitlist_infoContainer__29WMY","subTitle":"waitlist_subTitle__2uzil","heroImage":"waitlist_heroImage__1JCfZ"};